import type { Vector } from "./vector";

// Place the fatal line inside the physics clamp, at the outer edge of the sea.
export const SEA_BOUNDARY_INSET = 6;
export const SEA_BOUNDARY_WARNING_DISTANCE = 32;

export function seaBoundaryDistance(position: Vector, width: number, height: number): number {
    return Math.min(position.x, position.y, width - position.x, height - position.y) - SEA_BOUNDARY_INSET;
}

export function crossedSeaBoundary(position: Vector, width: number, height: number): boolean {
    return seaBoundaryDistance(position, width, height) <= 0;
}
